<template>
  <el-row>
    <el-row :gutter="12" class="mb-4">
      <el-card shadow="never">
        <el-col :span="12" v-for="(form, idx) in forms" :key="form.id">
          <el-form-item v-if="idx >= 0 && idx <= 3" :label="form.label">
            <el-select 
              v-if="form.type === 'select'" 
              style="width: 100%" 
              v-model="PushcartProduct[form.id]" 
              :placeholder="`Please input ${form.label}`"
              >
              <el-option
                v-for="item in form.data"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-input
              v-if="form.type == 'text' || form.type == 'number'"
              :disabled="form.disable"
              v-model="PushcartProduct[form.id]"
              :type="form.type"
              :placeholder="`Please input ${form.label}`"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-card>
    </el-row>
    <el-row :gutter="12" class="mb-4">
      <el-card shadow="never">
        <el-col :span="8" v-for="(form, idx) in forms" :key="form.id">
          <el-form-item v-if="idx >= 4 && idx <= 9" :label="form.label">
            <el-select 
              v-if="form.type === 'select'" 
              style="width: 100%" 
              v-model="PushcartProduct[form.id]" 
              :placeholder="`Please input ${form.label}`"
              >
              <el-option
                v-for="item in form.data"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-input
              v-if="form.type == 'text' || form.type == 'number'"
              :disabled="form.disable"
              v-model="PushcartProduct[form.id]"
              :type="form.type"
              :placeholder="`Please input ${form.label}`"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-card>
    </el-row>
    <el-row :gutter="12">
      <el-card shadow="never">
        <el-col :span="24">
          <el-upload
            class="upload-demo"
            style="width: 100%"
            drag
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div>
          </el-upload>
        </el-col>
      </el-card>
    </el-row>
  </el-row>
  
   
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: ["PushcartProduct", "from"],
  data() {
    return {
    };
  },
  methods: {
    ...mapActions({}),
  },
  computed: {
    forms() {
      return [
        {
          type: "select",
          id: "type",
          label: "Type",
          rules: [],
          data: [
            {
              name: "Type 1",
              value: "type1"
            },
            {
              name: "Type 2",
              value: "type2"
            },
            {
              name: "Type 3",
              value: "type3"
            },
            {
              name: "Type 4",
              value: "type4"
            }
          ]
        },
        {
          type: "select",
          id: "packingType",
          label: "Packing Type",
          rules: [],
          data: [
            {
              name: "Packing Type 1",
              value: "type1"
            },
            {
              name: "Packing Type 2",
              value: "type2"
            },
            {
              name: "Packing Type 3",
              value: "type3"
            },
            {
              name: "Packing Type 4",
              value: "type4"
            }
          ]
        },
        {
          type: "text",
          id: "upsellingName",
          label: "Upselling Name",
          rules: []
        },
        {
          type: "select",
          id: "upsellingProduct",
          label: "Upselling Product",
          rules: [],
          data: [
            {
              name: "Upselling Product 1",
              value: "upsellingType1"
            },
            {
              name: "Upselling Product 2",
              value: "upsellingType2"
            },
            {
              name: "Upselling Product 3",
              value: "upsellingType3"
            },
            {
              name: "Upselling Product 4",
              value: "upsellingType4"
            }
          ]
        },
        {
          type: "number",
          id: "realPrice",
          label: "Real Price",
          rules: []
        },
        {
          type: "number",
          id: "salePrice",
          label: "Sale Price",
          rules: []
        },
        {
          type: "number",
          id: "productQty",
          label: "Product Qty",
          rules: []
        },
        {
          type: "select",
          id: "discountType",
          label: "Discount Type",
          rules: [],
          data: [
            {
              name: "Discount Type 1",
              value: "type1"
            },
            {
              name: "Discount Type 2",
              value: "type2"
            },
            {
              name: "Discount Type 3",
              value: "type3"
            },
            {
              name: "Discount Type 4",
              value: "type4"
            }
          ]
        },
        {
          type: "number",
          id: "discountPrice",
          label: "Discount Price",
          rules: []
        },
        {
          type: "number",
          id: "maxDiscountPrice",
          label: "Max Discount Price",
          rules: []
        },
      ];
    },
    ...mapState({})
  },
  created() {}
};
</script>

<style>
</style>
